import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import screenfull from 'screenfull';
import { setLoadSuccess } from '../../../redux/actions/s2txtActions';
import ReactPlayer from 'react-player'
import { Slider, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const VolumeSlider = withStyles({
    root: {
      color: 'rgb(230, 230, 230)',
      height: 0,
      padding: 0,
      paddingTop: 2,
      margin: '0.1rem 0 0 0',
     
      width: 100,
     
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: 'rgb(230, 230, 230)',
      border: '1px solid rgb(230, 230, 230)',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#525252',
      opacity: 1
    },
  })(Slider);


function ValueLabelComponent(props) {
    const { children, open, value } = props;
  
    return (
      <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
        {children}
      </Tooltip>
    );
}

const PrettoSlider = withStyles({
root: {
    color: '#da3849',
    height: 0,
    padding: 0,
    paddingTop: 3,
    position: 'absolute',
    top: -6,
    width: '98.8%'
    
},
thumb: {
    height: 10,
    width: 10,
    backgroundColor: '#da3849',
    border: '2px solid currentColor',
    marginTop: -4,
    marginLeft: -0,
    '&:focus, &:hover, &$active': {
    boxShadow: 'inherit',
    },
},
active: {},
valueLabel: {
    left: 'calc(-50% + 4px)',
},
track: {
    height: 3,
    borderRadius: 4,
},
rail: {

    height: 3,
    borderRadius: 4,
    backgroundColor: '#909090',
    opacity: 1
},
})(Slider);


const timeFormat = (s) => {   
    var hrs = Math.floor(s / 3600);
    var mins = Math.floor((s % 3600) / 60);
    var secs = Math.floor(s % 60);
    var ret = "";
    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}


const VideoStream = ( { viewState, setLoadAudio, setAudioPlaying, videoSrc, playerContainerRef, setPlaying, playing, setError, audio, setLoadVideo, setViewState }) => {
    
    
    
    const [mute, setMute] = useState(false);
    const [volume, setVolume] = useState(0.5);
    const [duration, setDuration] = useState(1);
    const [videoLength, setVideoLength] = useState('00:00');
    const [currentTime, setCurrentTime] = useState('0:00');
    const [seekTime, setSeekTime] = useState('');
    const [screenStatus, setScreenStatus] = useState(false)
    const [gg, setgg] = useState('');
    const [pbr, setPbr] = useState(1);
    const [progress, setProgress] = useState({
        played: 0,
        playedSeconds: 0,
        seeking: false
    });
    

    const {played, playedSeconds, seeking} = progress
    const playerRef = useRef(null)
    
    const controlRef = useRef(null)
    const [playState, setPlayState] = useState('play');
    const dispatch = useDispatch()
    const [checkStatus, setCheckStatus] = useState(false)

    useEffect(() => {
        if(viewState === 'audio') {
            
            if (screenStatus) {
                toggleFullScreen()
                console.log('we get here')
            }
        }
    }, [playerContainerRef, screenStatus, viewState])

    useEffect(() => {
        setVideoLength(timeFormat(duration))

        if (playing) {
            setPlayState('play')
        } else {
            setPlayState('pause')
        }
    }, [duration, playing])

    useEffect(() => {
        if(viewState === 'audio') {
            if (document.querySelector('.video-controls')) {
                document.querySelector('.video-controls').classList.remove('remove')
            }
        }

        if(viewState === 'video') {
            if(checkStatus) {
                if (document.querySelector('.video-controls')) {
                    document.querySelector('.video-controls').classList.remove('remove')
                }
                
            }  
        }
    }, [checkStatus, viewState])

    const handlePlay = () => {
        setPlaying(true) 
        setCheckStatus(true)
    }

    const handlePause = () => {
        setPlaying(false)
    }

    const handleChange = (e, newValue) => {
        setVolume(newValue)
    }

    const handleMute = () => {
        setMute(!mute)
    }

    const toggleFullScreen = () => {
        setScreenStatus(true)
        screenfull.toggle(playerContainerRef.current)
        console.log(screenStatus)
    }

    const handleProgress = (changeState) => {
        setError(false)
        setCurrentTime(timeFormat(playedSeconds))
        if(!seeking) {
            setProgress({...changeState})
            setSeekTime(timeFormat(playedSeconds))
        }
        setgg((playedSeconds/duration) * 100)
        if( seekTime === (duration - 5)) {
            setDuration(parseInt(seekTime * 2))
          }

    }

    const handleDuration = (changeState) => {
        if(changeState === Infinity) {
            setDuration(20)
          } else {
            setDuration(parseInt(changeState))
          }
        
    }

    const onSeek = (e, newValue) => {
        setProgress({
            ...progress,
            played: parseFloat(newValue / 100)
        })
        setSeekTime(timeFormat(played * duration))
    }


    const onSeekMouseDown = (e, newValue) => {
        setProgress({
            ...progress,
            seeking: true,
            played: parseFloat(newValue / 100)
        })
    }

    const onSeekMouseUp = (e, newValue) => {
        setProgress({
            ...progress,
            seeking: false
        })
        playerRef.current.seekTo(newValue / 100)
    }

    const handleError = () => {
        // dispatch(setLoadFailed())
    }

    const handleReady = () => {
        dispatch(setLoadSuccess())
    }

    const handleViewAudio = () => {
        setLoadVideo(false)
        setViewState('audio')
        setAudioPlaying(false)
        setLoadAudio(false)
        setPlaying(false)
        
    }

    const handleViewVideo = () => {
        setViewState('video')
        setAudioPlaying(false)
        setLoadAudio(false)
        setPlaying(false)
        setLoadVideo(true)
    }

    const handleMouseLeave = () => {
        if(viewState === 'video') {
            setCheckStatus(false)
            if (document.querySelector('.video-controls')) {
                document.querySelector('.video-controls').classList.toggle('remove')
            }
        } else {
            
        }
        
    }

    return (
        <>          
            <ReactPlayer 
            ref={playerRef}
            className='react-player '
            width='100%'
            height='100%'
            url={videoSrc}
            muted={mute}
            playing={playing}
            volume={volume}
            playbackRate={pbr}
            onProgress={handleProgress}
            onDuration={handleDuration}
            onPlay={handlePlay}
            onPause={handlePause} 
            onError={handleError} 
            onReady={handleReady}
            onClick={handleMouseLeave}
            />

            <div className="video-controls">
                <PrettoSlider 
                min={0}
                max={100}
                defaultValue={0}
                value={played *100}
                onChange={onSeek}
                onMouseDown={onSeekMouseDown}
                onChangeCommitted={onSeekMouseUp}
                ValueLabelComponent={(props) => (
                <ValueLabelComponent {...props} value={seekTime}/>)}
                />

                <div className="controls  remove">
                    <div className="left">
                        {playState === 'play'? <i class="fas fa-pause" onClick={handlePause}></i> : <i class="fas fa-play" onClick={handlePlay}></i> }
                        
                        
                        
                        {mute ? <i class="fas fa-volume-mute volume" onClick={handleMute}></i> : volume <= '0.5'? <i class="fas fa-volume-down volume"  onClick={handleMute}></i> : <i class="fas fa-volume-up volume" onClick={handleMute}></i>}
                        
                        <VolumeSlider                                
                        value={volume} onChange={handleChange} 
                        aria-labelledby="continuous-slider" 
                        step={0.015}  
                        min={0}
                        max={1}
                        disabled={mute}/>
                    </div>

                    <div className="right">
                        
                        {audio? 
                        <div className="duration">
                            {currentTime}
                        </div>: 
                        <div className="duration">
                            {currentTime} / {videoLength}
                        </div>
                        }
                        
                        <div className="rectangle" onClick={toggleFullScreen}></div>

                        <div className="view-toggle-container">
                            {viewState === 'video'? 
                                <button className='view-button' onClick={handleViewAudio}>Audio Only</button>
                                :
                                <button className='view-button' onClick={handleViewVideo}>Video Mode</button>
                            }   
                        </div>
                    </div>
                </div> 
                
                
                   
            </div>
        </>

       
    )
}

export default  VideoStream